import axios from "axios";

const API_URL = "/api/observations";

export const createObservation = async (observationData) => {
    try {
        const response = await axios.post(`${API_URL}`, observationData);
        return response.data;
    } catch (error) {
        console.error("Error creating observation:", error);
        throw error;
    }
};

export const getObservationsByPatientId = async (patientId) => {
    try {
        const response = await axios.get(`${API_URL}/${patientId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching observations:", error);
        throw error;
    }
};

export const getObservationsByCategory = async (patientId, category) => {
    try {
        const response = await axios.get(`${API_URL}/${patientId}/category/${category}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching observations by category:", error);
        throw error;
    }
};

export const createObservationsBulk = async (observations) => {
  try {
    const response = await axios.post(`${API_URL}/bulk`, observations);
    return response.data;
  } catch (error) {
    console.error("Error creating observations in bulk:", error);
    throw error;
  }
};

